import { Flex, Text } from '@chakra-ui/react';
import { ReactComponent as AlertIcon } from 'assets/icons/a11ymenu_alert.svg';
import { ReactNode } from 'react';

type InputErrorProps = {
  children: ReactNode;
  // required for the inputs aria-describedby attribute for screen readers
  id: string;
};

export const InputError = ({ children, id }: InputErrorProps) => (
  <Flex alignItems='center'>
    <AlertIcon width={14} height={14} color='var(--vg-colors-red-500)' data-testid='error-alert-icon' />
    <Text id={id} ml='1' fontSize='xs' color='red.500'>
      {children}
    </Text>
  </Flex>
);
